import React, { FunctionComponent } from "react";
import { PersonalTaxForm } from "../types";
import { PersonalTaxFormNavigationButton } from "./PersonalTaxFormNavigationButton";
import { t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { ResetAangifteButton } from "./ResetAangifteButton";

export interface Props {
  activeForm: PersonalTaxForm;
  onChange: (form: PersonalTaxForm) => void;
}

export const PersonalTaxFormNavigation: FunctionComponent<Props> = ({ activeForm, onChange }) => {
  const { i18n } = useLingui();
  return (
    <div className="process">
      <div className="process-row nav nav-tabs">
        <PersonalTaxFormNavigationButton
          icon="info"
          title={i18n._(t`Personalia`)}
          active={activeForm === "personalia"}
          onClick={() => onChange("personalia")}
        />
        <PersonalTaxFormNavigationButton
          icon="user"
          title={i18n._(t`Burgerlijke staat`)}
          active={activeForm === "burgerlijksStaat"}
          onClick={() => onChange("burgerlijksStaat")}
        />
        <PersonalTaxFormNavigationButton
          icon="users"
          title={i18n._(t`Gezinslasten`)}
          active={activeForm === "gezinslasten"}
          onClick={() => onChange("gezinslasten")}
        />
        <PersonalTaxFormNavigationButton
          icon="list-ol"
          title={i18n._(t`Aangiftecodes`)}
          active={activeForm === "aangiftecodes"}
          onClick={() => onChange("aangiftecodes")}
        />
        <PersonalTaxFormNavigationButton
          icon="check"
          title={i18n._(t`Resultaat`)}
          active={activeForm === "resultaat"}
          onClick={() => onChange("resultaat")}
        />

        <ResetAangifteButton onReset={() => onChange("personalia")} />
      </div>
    </div>
  );
};

PersonalTaxFormNavigation.displayName = "PersonalTaxFormNavigation";
